'use strict';

import baseConfig from './base';
import { version } from './version';

let config = {
  version: version,
  guest_token: '1kQrjzlIY3AIpv83iWJ7Dv53vNECKWAM0vDVllnXSi3u8I22tuod4Rh1FNE5T5L0DjvNvurxoos8j9NnRYTeRS8tx2GIxlE3XfGBLdl5v23gdlsV9847yYj2vPolm9Os',
  stripe_key: 'pk_live_piH50bk7ujXQrWfJtzKS5BCa',
  api: 'https://authentication.msh-insurance.com/api/travel/insurance',
  headers: { Accept: 'application/vnd.ingle+json; version=1' },
  auth_base_api: 'https://authentication.msh-insurance.com',
  agent_portal: 'http://agents.msh-insurance.com',
  microsite_url: 'http://www.mshgroups.com',
  dashboard_url: 'https://dashboard.studyinsured.com',
  PPN_google_analytics_measurement_id: 'G-1W21RB5BET',
  microsite_google_analytics_measurement_id: 'G-WHKCZ6Q3MF',
  email: {
    policyConfirmation: {
      cc: [],
    }
  },
  ingle: {
    form_base_url: 'https://forms.msh-insurance.com',
  },
  rimi: {
    form_base_url: 'https://forms.rimiinsurance.com',
  },
  msg: {
    form_base_url: 'https://forms.msg-insurance.com',
  },
  visitcanada: {
    form_base_url: 'https://forms.2visitcanada-insurance.com',
  },
  insurecanada: {
    form_base_url: 'https://insurecanada.policy-forms.com',
  }
};

export default Object.freeze(Object.assign({}, new baseConfig, config));




// WEBPACK FOOTER //
// ./src/config/prod.js